import { Seo } from "@/components/Seo";
import { useLang } from "@/i18n";
import { Contact } from "@/components/Contact";

export default function ContactPage() {
  const { t } = useLang();
  return (
    <>
      <Seo title={t.seo.contact.title} description={t.seo.contact.description} path="/contact" />
      <Contact h1 />
    </>
  );
}
